import React from "react";
import LeadLogAccordianIndo from "./LeadLogAccordianIndo";
import PaginationModified from "../../../data/PaginationModified";

const LeadsLogsCard = ({
  tableData,
  setClickValues,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  handleDelete,
  isLeadLoading,
  userInfoData,
  handleCheckboxChange,
}) => {
  const isMarketing = userInfoData?.account_type === "marketing";

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {isLeadLoading ? (
        <div className="lead-v2-cycle-loading">
          <div className="lead-v2-loading-spinner"></div>
          <p>Loading leads...</p>
        </div>
      ) : tableData?.length > 0 ? (
        tableData.map((lead, index) => {
          const isDisbaled =
            lead?.lead_status?.toLowerCase() === "converted" ||
            lead?.lead_status?.toLowerCase() === "closed";

          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name name-checkbox">
                    {!isMarketing && (
                      <div className="select-multiple">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleCheckboxChange(event, lead)
                          }
                          checked={lead.checked}
                          disabled={isDisbaled}
                        />
                      </div>
                    )}
                    {lead?.name || "NA"}
                  </h3>

                  <span
                    className={`lead-type`}
                    style={{
                      background: "#5A56E4",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      marginTop: "2px",
                      letterSpacing: "1px",
                    }}
                  >
                    {lead?.follow_up_number || "-"}
                  </span>
                  {/* <span className={`lead-type ${lead?.lead_type}`}>
                    {lead?.lead_type?.replace(/_/g, " ") || "NA"}
                  </span> */}
                </div>

                <div className="card-other-info">
                  <span className="value semi-bold">
                    {lead?.mobile || "NA"}
                  </span>
                  {lead?.email ? (
                    <span className="value email semi-bold">
                      {lead?.email || "NA"}
                    </span>
                  ) : null}
                  <span className="value semi-bold">
                    {lead?.gym_name || "NA"}
                  </span>
                </div>

                <LeadLogAccordianIndo
                  rowData={lead}
                  setClickValues={setClickValues}
                  handleDelete={handleDelete}
                  isLeadLoading={isLeadLoading}
                  userInfoData={userInfoData}
                  isMarketing={isMarketing}
                />
              </div>
            </div>
          );
        })
      ) : null}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default LeadsLogsCard;
